import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const defaultMeta = {
  title: "Trademark Legal Forum | Trademark Registration & IP Protection Services",
  description: "Protect your brand with Trademark Legal Forum. Expert trademark registration, copyright, patent, company formation, and legal services across the USA. Starting at $45.",
  ogImage: "https://static.prod-images.emergentagent.com/jobs/90678b74-8893-4692-bfc7-d7847fcc33f8/images/c927193ed8f5a9f15489e086f7bfe3ce2b3009562c75ee2a007e373fdb65b63a.png"
};

export default function SEOHead({ title, description, ogImage, ogType = "website" }) {
  const location = useLocation();
  const pageTitle = title || defaultMeta.title;
  const pageDesc = description || defaultMeta.description;
  const pageImage = ogImage || defaultMeta.ogImage;
  const pageUrl = window.location.origin + location.pathname;

  useEffect(() => {
    document.title = pageTitle;

    const setMeta = (name, content, attr = "name") => {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", pageDesc);
    setMeta("og:title", pageTitle, "property");
    setMeta("og:description", pageDesc, "property");
    setMeta("og:image", pageImage, "property");
    setMeta("og:url", pageUrl, "property");
    setMeta("og:type", ogType, "property");
    setMeta("og:site_name", "Trademark Legal Forum", "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", pageTitle);
    setMeta("twitter:description", pageDesc);
    setMeta("twitter:image", pageImage);

    return () => {
      document.title = defaultMeta.title;
    };
  }, [pageTitle, pageDesc, pageImage, pageUrl, ogType]);

  return null;
}
